/* --------------------------------------------------------------------------------------
   languagesPopup.component.component.js
   Copyright © 2019 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export const languagesPopupComponent = {
  template: `
    <action-bar id="languages-action-bar" title="{{ 'LANGUAGE' | translate }}" ok="vm.ok()" cancel="vm.cancel()" disable-ok="!vm.selectedlanguage"></action-bar>
    <div xw-popup display="vm.display" custom-action-bar="#languages-action-bar">
      <table id="language-table" xw-table class="full-width-popup-table">
        <tr ng-repeat="lang in vm.languages" ng-click="vm.select(lang)" ng-class="{'ui-state-selected': lang == vm.selectedlanguage}">
          <td>{{lang}}</td>
        </tr>
      </table>
    </div>
    `,
  bindings: {
    display: '=',
    language: '='
  },
  controllerAs: 'vm',
  controller: class languagesPopupController {
    /* @ngInject */
    constructor(commonService, scanService) {
      this.commonService = commonService
      this.scanService = scanService
    }
    $onInit() {
      this.languages = this.scanService.languages
      //fix this
      if (this.language)
        this.selectedlanguage == this.language
    }
    select(language) {
      this.selectedlanguage = language
      this.commonService.updateView()
    }
    ok() {
      this.language = angular.copy(this.selectedlanguage)
      this.selectedlanguage = null
      this.display = false
      this.commonService.updateView()
    }
    cancel() {
      this.display = false
      this.commonService.updateView()
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/scan/components/languagesPopup.component.js